import {
  SEND_MESSAGE,
  SET_UPLOADED_FILE,
  SET_AGENT_LIST,
  SET_CONTACT_LIST2,
  SET_MESSAGE,
  SET_CUSTOMER_TYPING,
  SET_CHAT_SPINNER,
  SET_SEARCH_TERM,
  SET_MSG_TONE,
  SET_MSG_TONE2,
  SET_USERLIST_SHOW,
  SET_VALUE,
  REPORT_AGENTLIST_SUCCESS,
  REPORT_SKILLSET_SUCCESS,
} from "../../Redux/Actions/type";

export const initialState = {
  value: 0,
  userlistshow: true,
  pullcontact: false,
  msgTone: false,
  msgTone2: false,
  searchterm: "",
  uploadedFile: [],
  cannedMessage: [],
  showErrorAlert: false,
  errorMessage: "",
  contactList2: [],
  agentList: [],
  customerTyping: false,
  SentItemList: [],
  chatspinner: false,
};

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case REPORT_SKILLSET_SUCCESS: {
      return {
        ...state,
        skillsetdata: action.val,
      };
    }
    case SET_VALUE: {
      return {
        ...state,
        value: action.val,
      };
    }
    case SET_USERLIST_SHOW: {
      return {
        ...state,
        userlistshow: action.val,
      };
    }
    case SET_MSG_TONE: {
      return {
        ...state,
        msgTone: action.val,
      };
    }
    case SET_MSG_TONE2: {
      return {
        ...state,
        msgTone2: action.val,
      };
    }
    case SET_SEARCH_TERM: {
      return {
        ...state,
        searchterm: action.val,
      };
    }
    case SET_CHAT_SPINNER: {
      return {
        ...state,
        chatspinner: action.val,
      };
    }
    case SEND_MESSAGE:
      return {
        ...state,
        cannedMessage: action.val,
      };
    case SET_AGENT_LIST:
      return {
        ...state,
        agentList: action.val,
      };
    case SET_CONTACT_LIST2:
      return {
        ...state,
        contactList2: action.val,
      };
    case SET_UPLOADED_FILE: {
      return {
        ...state,
        uploadedFile: action.val,
      };
    }
    case SET_CUSTOMER_TYPING: {
      return {
        ...state,
        customerTyping: action.val,
      };
    }
    case SET_MESSAGE: {
      return {
        ...state,
        message: action.val,
      };
    }
    default:
      return state;
  }
};
